import { render } from "./FeaturedEdition.vue?vue&type=template&id=44575c9e&scoped=true"
import script from "./FeaturedEdition.vue?vue&type=script&lang=js"
export * from "./FeaturedEdition.vue?vue&type=script&lang=js"

import "./FeaturedEdition.vue?vue&type=style&index=0&id=44575c9e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\zacha\\repos\\jhhe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44575c9e"]])

export default __exports__